export default "__VITE_ASSET__BEOz6jpR__"